import { Component, OnInit, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';

import { SharedFunctions } from 'src/app/shared/shared.functions';

import { FaqService, TenantService } from 'src/app/shared/services';
import { ViewFaqRequestDto, ViewFaqItemDto, Tenant } from 'src/app/shared/model';

@Component({
    selector: 'app-faqPublicView',
    templateUrl: './faqPublicView.component.html',
    styleUrls: ['./faqPublicView.component.css']
})

export class FaqPublicViewComponent {
    searchForm: FormGroup;
    isSearching: boolean = false;
    hasSearched: boolean = false;
    isMobile: boolean = false;
    isTenantSearching: boolean = false;
    msgError: string = "";
    itemList: ViewFaqItemDto[];
    pageNumber: number = -1;
    tenantList: Tenant[];

    constructor (
        private formBuilder: FormBuilder,
        private location: Location,
        public dialog: MatDialog,
        private sharedFunctions: SharedFunctions,
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        public tenantService: TenantService,
        private faqService: FaqService
    ) {
    }

    ngOnInit(): void {
        this.loadView();
    }

    @HostListener('window:resize', ['$event'])
    sizeChange(event) {
        this.isMobile = (window.screen.width < 500);
    }

    trigger() {
        window.dispatchEvent(new Event('resize'));
    }

    loadView() {
        this.buildForm();
        this.getTenants();
    }

    buildForm() {
        this.searchForm = this.formBuilder.group({
            'TenantId': [null],
            'Texto': [null]
        });
    }

    getTenants() {
        this.isTenantSearching = true;
        this.tenantService.getAnonymousList().subscribe(data => {
          this.isTenantSearching = false;
          if (data != null) {
            this.tenantList = data?.Result;

            if (this.tenantList.length == 1) {
                this.searchForm.get("TenantId").setValue(this.tenantList[0].Id);
                this.onTenantSelect();
            }
          }
        },
        (err: HttpErrorResponse) => {
          this.isTenantSearching = false;
          this.sharedFunctions.handleError(err);
        });
    }

    onTenantSelect() {

        var t = this.searchForm.get("TenantId").value;
        this.pageNumber = -1;
        this.itemList = [];
        
        if (t != null && t > 0)
            this.onSearch();
    }

    hasTenantSelected() {
        var t = this.searchForm?.get("TenantId").value;
        return (t != null && t > 0);
    }

    onSearch() {
        this.hasSearched = true;
        this.pageNumber++;
        var search = new ViewFaqRequestDto(5, this.pageNumber, true, "Orden", null, null, null, true);
        search = Object.assign(search, this.searchForm.value);

        this.isSearching = true;
        this.faqService.viewFaqsPublic(search).subscribe(data => {
            this.isSearching = false;
            if (data != null) {
                if (data.result != null && data.result.length > 0) {
                    if (this.itemList == null)
                        this.itemList = [];

                    for (var i=0; i < data.result.length; i++) {
                        data.result[i].PreguntaHtml = this.sanitizer.bypassSecurityTrustHtml(data.result[i].Pregunta);
                        data.result[i].RespuestaHtml = this.sanitizer.bypassSecurityTrustHtml(data.result[i].Respuesta);
                        data.result[i].Adjuntos = data.result[i].Adjuntos?.filter(f => !f.IncluidoEnCuerpoMensaje);

                        this.itemList.push(data.result[i]);
                    }
                }
            }
            else
                this.msgError = "Ocurrió un error al intentar obtener los datos de las FAQs.";
        },
        (err: HttpErrorResponse) => {
            this.isSearching = false;
            this.sharedFunctions.handleError(err, true);
        })
    }

    onFilterSearch() {
        this.pageNumber = -1;
        this.itemList = [];
        
        this.onSearch();
    }

    onCancel() {
        this.location.back();
    }
}